import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { CargoPayload, Operation } from "../utils/types/cargo";

export const fetchCargoList = async (berthId: string) => {
  const response = await axiosServices.get("/cargo", {
    params: {
      bearthId: berthId,
    },
  });
  return convertToCamelCase<Operation[]>(response.data.data);
};

export const updateCargo = async (
  id: string,
  berthId: string,
  data: {
    [key: string]: any;
    cargoId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/cargo/${id}`, inputData, {
    params: {
      berthId,
    },
  });
};

export const deleteCargo = async (data: { id: string; berthId: string }) => {
  const response = await axiosServices.delete(`/cargo/${data.id}`, {
    params: {
      berthId: data.berthId,
    },
  });
  return response.data;
};

export const addCargo = async (data: CargoPayload) => {
  const payloadData = convertToSnakeCase(data);
  const response = await axiosServices.post<{ data: Operation }>(
    "/cargo",
    payloadData,
    {
      params: {
        berthId: data.berthId,
      },
    }
  );
  return convertToCamelCase<Operation>(response.data.data);
};

export const moveCargo = async (id: string, berthId: string) => {
  await axiosServices.put(`/cargo/${id}`, {
    berth_id: berthId,
  });
};
